import { FormControl, FormLabel, Switch, Typography } from '@mui/material';
import React from 'react';
import { Helmet } from 'react-helmet';
import { VyPageLayout } from '../../../components/new-design/layout/VyPageLayout';
import { FormErrorNotificationProvider } from '../../../contexts/form-error-notification-context/FormErrorNotificationProvider';
import { CreateInvoiceErrorNotification } from './create-invoice-page-components/CreateInvoiceErrorNotification/CreateInvoiceErrorNotification';
import { withCreateInvoiceForm } from './create-invoice-page-components/CreateInvoiceForm/CreateInvoiceForm';
import { CreateInvoicePageContent } from './create-invoice-page-components/CreateInvoicePageContent';
import { CreateInvoicePageStepperNavigator } from './create-invoice-page-components/CreateInvoicePageStepperNavigator';
import { useCreateInvoiceContext } from './create-invoice-page-contexts/create-invoice-context/create-invoice-context';

const CreateInvoicePage: React.FC = () => {
  const {
    planPreview: { open, hide, show },
  } = useCreateInvoiceContext();

  const handlePlanPreviewSwitch = (_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    checked ? show() : hide();
  };

  return (
    <VyPageLayout
      showBackButton
      title="Create Invoice"
      sx={{
        padding: '0',
      }}
      action={
        <FormControl className="flex flex-row items-center gap-x-2">
          <FormLabel htmlFor="plan-preview-switch">
            <Typography variant="body1" sx={{
              color: "text.primary"
            }}>
              See Preview
            </Typography>
          </FormLabel>
          <Switch id="plan-preview-switch" checked={open} onChange={handlePlanPreviewSwitch} />
        </FormControl>
      }
    >
      <Helmet>
        <title>Create Invoice</title>
      </Helmet>
      <FormErrorNotificationProvider>
        <div className="flex h-full flex-col">
          <CreateInvoicePageContent />

          <CreateInvoicePageStepperNavigator />

          <CreateInvoiceErrorNotification />
        </div>
      </FormErrorNotificationProvider>
    </VyPageLayout>
  );
};

const CreateInvoicePageWithPageLayout = withCreateInvoiceForm(CreateInvoicePage);

export { CreateInvoicePageWithPageLayout as CreateInvoicePage };
